(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/ssn-input/assets/javascripts/components/ssn-input.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/ssn-input/assets/javascripts/components/ssn-input.trinidad.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (ssn_input)
  });
  ; 
  const external_React_namespaceObject = window["React"];
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  const _excluded = ["errorMessageDefault", "errorMessageRequired", "helpMessage", "infoMessage", "isRequired", "label", "name", "isLessSpace", "onBlur", "onChange", "onFocus", "value"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  const SSNInput = _ref => {
    let errorMessageDefault = _ref.errorMessageDefault,
      errorMessageRequired = _ref.errorMessageRequired,
      helpMessage = _ref.helpMessage,
      infoMessage = _ref.infoMessage,
      isRequired = _ref.isRequired,
      label = _ref.label,
      name = _ref.name,
      isLessSpace = _ref.isLessSpace,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);
    const dashRegexp = /([0-9]{8})(?!-)/;
    const prependTwentyRegexp = /^0/;
    const prependNineteenRegexp = /^[3-9]{1,1}|^(?!19|20)[0-9]{2,2}|^190|^(?!200)[2-9][0-9]{2,2}/;
    const _ref3 = (0, external_React_namespaceObject.useState)(0),
      _ref4 = _slicedToArray(_ref3, 2),
      selectionStart = _ref4[0],
      setSelectionStart = _ref4[1];
    const ssnValidation = (pnrReg, ssn) => {
      let isValid = false;
      const pnr = {
        valid: false
      };
      if (pnrReg.test(ssn)) {
        isValid = true;
      }
      if (isValid) {
        pnr.now = new Date();
        pnr.nowFullYear = String(pnr.now.getFullYear());
        pnr.nowCentury = pnr.nowFullYear.substring(0, 2);
        pnr.nowShortYear = pnr.nowFullYear.substring(2, 4);
        pnr.year = RegExp.$1;
        pnr.month = RegExp.$2;
        pnr.day = RegExp.$3;
        pnr.controldigits = RegExp.$4;
        pnr.fullYear = Number(pnr.year) <= Number(pnr.nowShortYear) ? (pnr.nowCentury + pnr.year) * 1 : (Number(pnr.nowCentury) - 1 + pnr.year) * 1;
        const months = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (pnr.fullYear % 400 === 0 || pnr.fullYear % 4 === 0 && pnr.fullYear % 100 !== 0) {
          months[1] = 29;
        }
        if (Number(pnr.month) < 1 || Number(pnr.month) > 12 || Number(pnr.day) < 1 || Number(pnr.day) > months[Number(pnr.month) - 1]) {
          return false;
        }
        pnr.alldigits = pnr.year + pnr.month + pnr.day + pnr.controldigits;
        let nn = '';
        for (let n = 0; n < pnr.alldigits.length; n++) {
          nn += ((n + 1) % 2 + 1) * pnr.alldigits.substring(n, n + 1);
        }
        pnr.checksum = 0;
        for (let m = 0; m < nn.length; m++) {
          pnr.checksum += Number(nn.substring(m, m + 1));
        }
        pnr.valid = pnr.checksum % 10 === 0;
      }
      return pnr.valid;
    };
    const validateBankIdSsn = ssn => ssnValidation(/^\d{2}(\d{2})(\d{2})(\d{2})-(\d{4})$/, ssn);
    const validate = (event, value) => {
      const isValidSSN = validateBankIdSsn(value);
      const hasValue = value.length > 0;
      let isValid = hasValue && isValidSSN;
      let currentErrorMessage = '';
      if (event === 'onSubmit' && isRequired && !hasValue) {
        currentErrorMessage = errorMessageRequired;
      } else if (!isValidSSN) {
        currentErrorMessage = errorMessageDefault;
      }
      if (event === 'onBlur' || !isRequired) {
        isValid = isValidSSN;
        if (value === '') {
          isValid = true;
          currentErrorMessage = '';
        }
      }
      return {
        errorMessage: currentErrorMessage,
        isValid,
        name
      };
    };

    const checkSumCalc = number => {
      let sum = 0;
      const delta = [0, 1, 2, 3, 4, -4, -3, -2, -1, 0];
      let i;
      number = number.substring(2);
      for (i = 0; i < number.length; i++) {
        sum += parseInt(number.charAt(i), 10);
      }
      for (i = number.length - 1; i >= 0; i -= 2) {
        sum += delta[parseInt(number.charAt(i), 10)];
      }
      if (10 - sum % 10 === 10) {
        return 0;
      }
      return 10 - sum % 10;
    };
    const prependDigits = number => {
      if (number) {
        number = number.trim();
        if (number.match(prependTwentyRegexp)) {
          number = "20".concat(number);
        } else if (number.match(prependNineteenRegexp)) {
          number = "19".concat(number);
        }
        if (number.length >= 8) {
          number = number.replace(dashRegexp, '$1-');
        }
      }
      return number;
    };
    const onKeyupHandler = e => {
      const keyCode = e.charCode || e.keyCode;
      let ssn;

      if (keyCode !== 8 && keyCode !== 46) {
        if (value.length === 12) {
          ssn = value.replace(/-/g, '');
          if (!isNaN(parseInt(ssn, 10)) && value.indexOf('-') > -1) {
            onChange({
              target: {
                name,
                value: value + checkSumCalc(ssn)
              }
            });
          }
        } else if (value.length < 4 || value.length === 8) {
          onChange({
            target: {
              name,
              value: prependDigits(value)
            }
          });
        }
      }
    };
    const onClickHandler = () => {
      const newValue = prependDigits(value);
      if (value.length !== newValue.length) {
        onChange({
          target: {
            name,
            value: newValue
          }
        });
        setSelectionStart(newValue.length);
      }
    };
    const onInputHandler = e => onChange({
      target: {
        name,
        value: e.target.value.length > 9 ? prependDigits(e.target.value) : e.target.value
      }
    });
    return React.createElement(external_svs_ui_ReactForm_namespaceObject.FormContext.Consumer, null, _ref2 => {
      let form = _ref2.form,
        handleBlur = _ref2.handleBlur,
        handleChange = _ref2.handleChange,
        handleFocus = _ref2.handleFocus,
        register = _ref2.register;
      return React.createElement(external_svs_ui_ReactForm_namespaceObject.ControlGroup, {
        errorMessage: form[name] && form[name].errorMessage,
        hasError: form[name] && !form[name].isValid,
        infoMessage: infoMessage,
        isLessSpace: isLessSpace,
        v2: true
      }, React.createElement(external_svs_ui_ReactForm_namespaceObject.Inputv2, _extends({
        autoCapitalize: "off",
        autoComplete: "bdate",
        autoCorrect: "off",
        inputHelpText: helpMessage,
        label: label,
        maxLength: "13",
        name: name,
        onBlur: e => {
          handleBlur(e, onBlur);
        },
        onClick: onClickHandler,
        onFocus: e => {
          handleFocus(e, onFocus);
        },
        onInput: e => {
          handleChange(e, onInputHandler);
        },
        onKeyUp: onKeyupHandler,
        pattern: "\\d{8}-\\d{4}",
        refElem: register(name, validate),
        selectionend: selectionStart,
        selectionstart: selectionStart,
        spellCheck: "false",
        type: "text",
        value: value
      }, props)));
    });
  };
  SSNInput.defaultProps = {
    errorMessageDefault: 'Felaktigt personnummer, använd formatet YYYYMMDD-XXXX',
    errorMessageRequired: 'Du måste ange personnummer',
    helpMessage: 'ÅÅÅÅMMDD-XXXX',
    isRequired: true,
    label: 'Ange personnummer'
  };
  SSNInput.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "SSNInput",
    "props": {
      "errorMessageDefault": {
        "defaultValue": {
          "value": "'Felaktigt personnummer, anv\xE4nd formatet YYYYMMDD-XXXX'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessageRequired": {
        "defaultValue": {
          "value": "'Du m\xE5ste ange personnummer'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "helpMessage": {
        "defaultValue": {
          "value": "'\xC5\xC5\xC5\xC5MMDD-XXXX'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isRequired": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "label": {
        "defaultValue": {
          "value": "'Ange personnummer'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "infoMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isLessSpace": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "name": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      },
      "onBlur": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onChange": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": true
      },
      "onFocus": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      }
    }
  };
  const ssn_input = SSNInput;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactFormInputs = window.svs.ui.ReactFormInputs || {}).SSNInput = __webpack_exports__["default"];
})();

 })(window);